import React from 'react';
import {URLS} from "@/lib/urls";
import StudentLayout from "@/components/layout/student/studentLayout";
import {useApiSearchStudentSurveyPublic} from "@/api/survey";
import SurveyCard from "@/pages/student/survey/list/_section/SurveryCard";
import RenderIf from "@/components/render-if";
import {Empty} from "antd";

function StudentPublicSurveyList(props) {
    const {data: survey, isLoading} = useApiSearchStudentSurveyPublic();
    return (
        <StudentLayout pageTitle={'نظرسنجی‌ها'} backTo={URLS.student.dashboard}>
            <RenderIf condition={survey?.data?.data?.length === 0}>
                <div>
                    <Empty description={'در حال حاضر نظرسنجی فعال وجود ندارد'}/>
                </div>
            </RenderIf>
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
                {survey?.data?.data.map((survey) => (
                    <SurveyCard
                        key={survey.id + 'student-survey'}
                        survey={survey}
                    />
                ))}
            </div>
        </StudentLayout>
    );
}

export default StudentPublicSurveyList;